import { onMounted, onUnmounted, type Ref } from "vue";

export function useTimelineElementListeners(timelineRef: Ref<HTMLElement | null>, handlers: {
    onPointerDown?: (e: PointerEvent) => void,
    onPointerMove?: (e: PointerEvent) => void,
    onPointerUp?:   (e: PointerEvent) => void,
    blockWheelAndTouch?: boolean
}) {
    let abortCtrl: AbortController | null = null;

    onMounted(() => {
        const tl = timelineRef.value ?? document.getElementById("timeline");
        if (!tl) { return; }

        if (handlers.onPointerDown) { tl.addEventListener("pointerdown", handlers.onPointerDown); }
        if (handlers.onPointerMove) { tl.addEventListener("pointermove", handlers.onPointerMove); }
        if (handlers.onPointerUp) {
            tl.addEventListener("pointerup", handlers.onPointerUp);
            tl.addEventListener("pointerleave", handlers.onPointerUp);
        }

        if (handlers.blockWheelAndTouch) {
            abortCtrl = new AbortController();
            const opts: AddEventListenerOptions = { capture: true, passive: true, signal: abortCtrl.signal };
            const wheelBlocker: EventListener = ev => { ev.stopImmediatePropagation(); };
            const touchBlocker: EventListener = ev => { (ev as TouchEvent).stopImmediatePropagation(); };
            tl.addEventListener("wheel", wheelBlocker, opts);
            tl.addEventListener("touchmove", touchBlocker, opts);
        }
    });

    onUnmounted(() => {
        const tl = timelineRef.value ?? document.getElementById("timeline");
        if (tl) {
            if (handlers.onPointerDown) tl.removeEventListener("pointerdown", handlers.onPointerDown);
            if (handlers.onPointerMove) tl.removeEventListener("pointermove", handlers.onPointerMove);
            if (handlers.onPointerUp) {
                tl.removeEventListener("pointerup", handlers.onPointerUp);
                tl.removeEventListener("pointerleave", handlers.onPointerUp);
            }
        }
        abortCtrl?.abort();
    });
}